// tslint:disable:max-line-length
import { Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";

import { BASE_CONSTANTS, ITCIUserInfo } from "@tci/common";
import { NgToolsService } from "../ng-util/ng-tools.service";
import { NgWsDiscoveryService } from "./ng-ws-discovery.service";
import { NgUserService } from "./ng-user.service";

@Injectable()
export class NgAuthGuardService implements CanActivate {

    private loginUrl$: Observable<string>;
    private signupUrl$: Observable<string>;

    constructor(
        private location: Location,
        private router: Router,
        private tools: NgToolsService,
        private userService: NgUserService,
        private wsDiscovery: NgWsDiscoveryService
    ) {
        this.loginUrl$ = Observable
            .concat(
                this
                    .wsDiscovery
                    .getEnableTSCIntegrationVar(),
                this
                    .wsDiscovery
                    .getTciTenantId(),
                this
                    .wsDiscovery
                    .getLoginServiceUrl()
            )
            .toArray()
            .map(
                ([
                    enableTSCIntegrationVar,
                    tciTenantId,
                    loginServiceUrl
                ]) => {
                    return `${loginServiceUrl}?relayState=${encodeURIComponent(
                        this.constructRelayState(enableTSCIntegrationVar, tciTenantId)
                    )}`;
                }
            );
        this.signupUrl$ = this
            .wsDiscovery
            .getTscSignupUrl();
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> {
        return this
            .userService
            .getUserInfo()
            .mergeMap((userInfo: ITCIUserInfo) => {
                if (userInfo === null) {
                    return this.asyncRedirect(this.loginUrl$);
                } else {
                    if (userInfo.reg) {
                        if (userInfo.dsbl) {
                            return Observable.of(this.tools.goToPath(BASE_CONSTANTS.DISABLED_ERROR));
                        } else {
                            if (state.url === "/register") {
                                return Observable.of(this.tools.goToPath("applications"));
                            }
                            return Observable.of(true);
                        }
                    } else {
                        if (state.url !== "/register") {
                            return Observable.of(this.tools.goToPath(BASE_CONSTANTS.UNREGISTERED_ERROR));
                        } else {
                            return this.asyncRedirect(this.signupUrl$);
                        }
                    }
                }
            })
            .catch(() => {
                if (state.url === "/register") {
                    return this.asyncRedirect(this.signupUrl$);
                } else {
                    return this.asyncRedirect(this.loginUrl$);
                }
            });
    }

    private constructRelayState(enableTSCIntegrationVar, tenantId): string {
        const location = (<any>window).location;
        const btoa = (<any>window).btoa;
        const oldRelayObject = {
            resumeURL: location.href,
            registerURL: `${location.protocol}://${location.hostname}${location.port ? ":" + location.port :
                ""}/register`,
            welcomeURL: `${location.protocol}://${location.hostname}${location.port ? ":" + location.port :
                ""}/applications`
        };
        const newRelayObject = {
            resumeURL: location.href,
            welcomeURL: `${location.protocol}://${location.host}${location.port ? ":" + location.port :
                ""}/applications`,
            tenantId: tenantId
        };
        const jsonObj = enableTSCIntegrationVar ? newRelayObject : oldRelayObject;

        return btoa(JSON.stringify(jsonObj));
    }

    private asyncRedirect(url$: Observable<string>): Observable<boolean> {
        return url$
            .map((url: string) => {
                return this.tools.goToUrl(url);
            });
    }
}
